import { onCleanup, Show } from "solid-js";
import style from './st-job-queue-status.module.css'
import { JobQueueStatusInfo, JobState, ReportExportFilterType } from 'st-app/api'
import { render } from "solid-js/web";
import Dropdown from "../st-dropdown/st-dropdown";
import { useJobQueueStatusContext } from "./JobQueueStatusContext";
import { JobQueuePanel } from "./fragments/JobQueuePanel";
import { JobDetail } from "./fragments/JobDetail";
import { openViewInDialog } from "../st-view/st-view";
import Button, { ButtonType } from "../st-button/st-button";

export class JobQueueStatusProps { }



export default function JobQueueStatus() {
    const jqContext = useJobQueueStatusContext();
    jqContext.refreshStatusList();
    jqContext.refreshHistoricalJobs();

    return (
        <Dropdown>
            <Dropdown.Trigger class={style.icon} action="hover">
                <i class={`fa fa-gear ${style['gear-1']}`} classList={{ 'fa-spin': jqContext.isProcessing() }}></i>
                <i class={`fa fa-gear reverse ${style['gear-2']}`} classList={{ 'fa-spin': jqContext.isProcessing() }}></i>

                <Show when={jqContext.showBadge()}>
                    <div class={`${style.badge} ${jqContext.iconBadgeColor() ? style[jqContext.iconBadgeColor()] : ''}`}>
                        {jqContext.iconBadgeCount()}
                    </div>
                </Show>
            </Dropdown.Trigger>

            <Dropdown.Content as={JobQueuePanel} />
        </Dropdown>
    )
}
JobQueueStatus.defaultProps = new JobQueueStatusProps();



export enum JobCategory {
    Controller = 'C',
    Dependent = 'D',
    Maintenance = 'M',
}

const JQ_CONTROLLER_VIEW_GU = '603E6071-9313-4552-828A-885490F40BCB';

export const viewJob = (job: JobQueueStatusInfo) => {
    switch (job.state) {
        case JobState.Hold:
        case JobState.Waiting:
        case JobState.InProgress:
            if (job.category === JobCategory.Controller) {
                openViewInDialog(JQ_CONTROLLER_VIEW_GU, job.processQueueGU!);
            } else {
                showJobDetails(job);
            }
            break;
        case JobState.CtlInProgress:
            openViewInDialog(JQ_CONTROLLER_VIEW_GU, job.processQueueGU!);
            break;
        default:
            viewResults(job);
            break;
    }

    try {
        const jqContext = useJobQueueStatusContext();
        jqContext.moveToHistorical(job);
        jqContext.refreshStatusList();
    } catch(e) { console.error(e) }
}

export const launchRI = (job: JobQueueStatusInfo) => {
    if (!job.reportGU) {
        return
    }
    if (window.ST?.OpenWindow) {


        window.ST.OpenWindow({
            'REV_RENDER': {
                '@FOCUS_KEY': job.focusKey,
                'VIEW': {
                    '@GUID': job.reportGU,
                    '@RENDER_VIEW': 'YES',
                    '@MODE': 'NORMAL',
                    '@TYPE': 'REPORT',
                    '@SHOW_SUBTITLE': 'Y',
                    '@MODAL': 'YES',
                    'REV_DATA_ROOT': {
                        '@ACTION': 'CURRENT',
                        '@PRIMARY_OBJECT': '',
                        'CLIENT_STATE': {
                            'CLIENT_ACTION': {
                                '@TYPE': 'SAVE_PARENT_COMMAND',
                                '@BUTTON_ID': 'LAUNCH_RI',
                                '@ELEMENT_ID': 'REV_BUTTON',
                                '@IN_GRID': 'Y',
                            },
                        },
                        'REV_DATA_REQUEST': {
                            'REV_VIEW': {
                                '@GUID': job.reportGU,
                            },
                        },
                    },
                },
                'SERVER_STATE': {
                    'D': {
                        '@K': '__REPORT_PROCCESS_QUEUE_GU__', '@V': job.processQueueGU || ''
                    },
                },
            },
        });

        return
    }

    alert('Launch RI not implemented')
}

const showJobDetails = (job: JobQueueStatusInfo) => {
    if (import.meta.env.DEV) {
        const dispose = render(() => (
            <JobDetail processQueueGU={job.processQueueGU!} />
        ), document.body)
    
        return { dispose };
    }

    window.ST.JobQueue.ShowJobDetails(job.processQueueGU!);
}

const viewResults = (job: JobQueueStatusInfo) => {
    if (window.ST?.JobQueue?.ViewResults) {
        viewResultsLegacy(job)
        return;
    }

    alert('View results not implemented')
}


const viewResultsLegacy = (job: JobQueueStatusInfo) => {
    // if document validation result
    if (job.type == 'D' || job.type == 'ACT') {
        window.ST.JobQueue.GetDocValResults(job.processQueueGU);
        return;
    }

    var xmlObj = {
        '@FOCUS_KEY': window.ST.RevFocusKey,
        '@GUID': job.processQueueGU,
        '@MARK_READ': 'Y'
    };

    if (job.multiResultFile) {
        window.ST.SendServerEvent(null, 'JobQueue_Get_MultiResults', xmlObj)
            .done(function (response: any) {
                // DONT MAKE A HABIT OF THIS. THIS ts-ignore IS HERE SOLEY BECAUSE IMPLEMENTING THE
                // ENTIRETY OF FILE DOWNLOADING WAS TOO MUCH WORK FOR THIS FEATURE
                // THIS WILL GO AWAY EVENTUALLY, AND WE ARE ONLY DOING THIS BECAUSE WE WILL
                // NOT BE EXPOSING JQUERY IN ANY KIND OF GLOBAL TYPES.
                // TLDR: DONT USE ts-ignore AND DONT USE JQUERY
                //@ts-ignore
                var resultNode = $(response && response.documentElement).find('JOB_QUEUE_MULTIRESULTS')[0];
                window.ST.JobQueue.ShowMultiResultDialog(resultNode);
            });
    }
    else {
        var resultType = job.resultType;
        var typesToShow = [
            ReportExportFilterType.HTML,
            ReportExportFilterType.PDF,
            ReportExportFilterType.Txt,
            ReportExportFilterType.RTF,
            ReportExportFilterType.TIFF,
            ReportExportFilterType.Excel,
            ReportExportFilterType.ExcelXLSX,
            ReportExportFilterType.XML,
            ReportExportFilterType.CSV,
            ReportExportFilterType.Fixed,
            ReportExportFilterType.WordDOCX,
            ReportExportFilterType.ZIP
        ];

        if (job.primaryResultFile || typesToShow.includes(resultType) || job.type === JobCategory.Controller) {
            window.ST.SendServerEvent(null, 'JobQueue_Get_Results', {
                '@FOCUS_KEY': window.ST.RevFocusKey,
                '@JOB_GUID': job.processQueueGU,
                '@FILE_GUID': job.primaryResultFile,
            });
        }
    }
}

export {
    useJobQueueStatusContext
}